import { QuestionMarkedMultiple } from '@/components/features/quiz/question/question-marked/question-multiple';
import { QuestionBase } from '@/components/features/quiz/question/question-resolver';
import { useQuestionMultiple } from '@/hooks/questions';

import type { QuestionMultipleProps } from '.';

import { QuestionMultipleAnswer } from './QuestionMultipleAnswer';

export function QuestionMultiple(questionMultipleProps: QuestionMultipleProps) {
  const { question, showMarked } = questionMultipleProps;
  const { marked, answers, exportedUserAnswer, onCheckedChange, isChecked, getMarkedState } = useQuestionMultiple(questionMultipleProps);

  return (
    <QuestionBase content={question.content} type={question.type}>
      <div className="grid gap-3">
        {answers.map((answer) => (
          <QuestionMultipleAnswer
            key={answer.id}
            answer={answer}
            showMarked={showMarked}
            correct={getMarkedState(answer)}
            checked={isChecked(answer.id)}
            onCheckedChange={(checked) => onCheckedChange(answer.id, checked)}
          />
        ))}
      </div>
      <QuestionMarkedMultiple showMarked={showMarked} marked={marked} question={question} answer={exportedUserAnswer} showQuestion={false} />
    </QuestionBase>
  );
}
